import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export enum HeadingSpacing {
  'NONE' = 0,
  'X_SMALL' = 8,
  'SMALL' = 16,
  'MEDIUM' = 24,
  'LARGE' = 32,
  'X_LARGE' = 40,
  'XX_LARGE' = 48,
}
@Component({
  standalone: true,
  selector: 'app-heading',
  imports: [CommonModule],
  templateUrl: './heading.component.html',
  styleUrl: './heading.component.css',
})
export class HeadingComponent {
  @Input() titleLevel: 0 | 1 | 2 | 3 = 1;
  @Input() headingLevel: 1 | 2 = 1;
  @Input() testId!: string;
  @Input() spacingBottom = HeadingSpacing.NONE;
}
